import axios from "axios";

axios.defaults.withCredentials = false;



// Base URL de la API. Por defecto apunta al entorno local.
// Puede sobreescribirse definiendo la variable REACT_APP_API_URL.
export const API_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
  // export const API_URL ='http://localhost:8000/api';

// URL base del backend para peticiones fuera del prefijo /api
export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
// export const BACKEND_URL = 'http://localhost:8000';

const withAuth = config => {
  const token = localStorage.getItem('token');
  return token ? { ...config, headers: { ...config.headers, Authorization: `Bearer ${token}` } } : config;
};

axios.interceptors.request.use(withAuth);

axios.interceptors.response.use(
  response => response,
  error => {
    const method = error.config?.method;
    if (method === 'get') {
      window.location.href = '/error';
    }
    return Promise.reject(error);
  }
);

const authHeader = {
  headers: {
    'Content-type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json',
  }
};

const withoutAuthHeader = {
  headers: {
    'Content-type': 'application/json',
    'Accept': 'application/json',
  }
}

const getAuthHeader = () => ({
  headers: {
    'Content-type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
  }
});

const getAuthFormHeader = () => ({
  headers: {
    // Let axios set the correct multipart boundaries
    'Accept': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
  }
});

const getAuthJsonHeader = () => ({
  headers: {
    'Content-type': 'application/json',
    'Accept': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
  }
});

// Obtener token desde almacenamiento para autenticación por cabecera




//Funcion para obtener el token
// export const login = async (email, password) => {
//     let opciones = {
//         method: 'POST',
//         headers: {
//             'Content-type': 'application/x-www-form-urlencoded',
//             'Accept': 'application/json',
//         },
//         body: `email=${email}&password=${password}`
//     };

//     const res = await fetch(`${API_URL}/login`, opciones);
//     if (!res.ok) return null;

//     const { access_token } = await res.json();
//     localStorage.setItem('token', access_token);
 
//     const user = await getUser(email, password);

//     // return await getUser(email, password);
//     return { user, access_token };
// }


// Login devuelve { access_token, user, roles }
export async function login(email, password) {
  const data = new URLSearchParams();
  data.append('email', email);
  data.append('password', password);
  try {
    const res = await axios.post(`${API_URL}/login`, data, authHeader);
    localStorage.setItem('token', res.data.access_token);
    return await getUserData();
  } catch {
    return null;
  }




}

// Obtener perfil utilizando el token almacenado
export const getUserData = async () => {
  try {
    const res = await axios.post(`${API_URL}/datauser`, null, getAuthHeader());
    return {
      ...res.data,
      user: {
        ...res.data.user,
        last_name: res.data.user?.last_name || ''
      }
    };
  } catch {
    return null;
  }
};

export const logout = async () => {
  await axios.post(`${API_URL}/logout`, null, getAuthHeader());
  localStorage.removeItem('token');
}

// Funcion para obtener todos los usuarios
export const getAllUsers = async () => {
    return await axios
      .get(`${API_URL}/admin/users`, getAuthHeader())
      .then(response => response.data);
}



// Funcion para registrar un usuario
export const registerUser = async (
  name,
  lastName,
  email,
  password,
  role,
  serviceId,
  bio = '',
  image = null,
  categoryId = '',
  color = '',
  featured = false,
  employeeOrder = '',
  active = true,
  showInAbout = true
) => {
  const formData = new FormData();
  formData.append('email', email);
  formData.append('password', password);
  formData.append('name', name);

  if (lastName) formData.append('last_name', lastName);

  formData.append('role', role);
  if (serviceId) formData.append('service_id', serviceId);
  if (categoryId) formData.append('category_id', categoryId);
  if (bio) formData.append('bio', bio);
  if (image) formData.append('image', image);
  if (color) formData.append('color', color);
  formData.append('featured', featured ? '1' : '0');
  formData.append('active', active ? '1' : '0');
  formData.append('show_in_about', showInAbout ? '1' : '0');
  if (employeeOrder !== '' && employeeOrder !== null && employeeOrder !== undefined) {
    formData.append('employee_order', String(employeeOrder));
  }

  try {
    const res = await axios.post(
      `${API_URL}/register`,
      formData,
      getAuthFormHeader()
    );
    return res.data;
  } catch (e) {
    return { error: e.response?.data?.message || 'Error registrando usuario' };



  }
};




export const getUserById = async (id) => {

    return await axios.get(`${API_URL}/users/${id}`, getAuthHeader()).then(response => response.data);
}

// Funcion para actualizar los datos de un usuario
export const updateUser = async (
  id,
  name,
  lastName = '',
  email,
  rol,
  password = '',
  bio = '',
  image = null,
  categoryId = '',
  serviceId = '',
  color = '',
  featured = false,
  employeeOrder = '',
  removeImage = false,
  active = null,
  showInAbout = null
) => {
  const data = new FormData();
  data.append('name', name);
  if (lastName) data.append('last_name', lastName);
  data.append('email', email);
  if (password) data.append('password', password);
  data.append('roles', rol);
  if (bio !== undefined) data.append('bio', bio);
  if (image) data.append('image', image);
  if (removeImage) data.append('remove_image', '1');
  if (categoryId) data.append('category_id', categoryId);
  if (serviceId) data.append('service_id', serviceId);
  if (color) data.append('color', color);
  data.append('featured', featured ? '1' : '0');
  if (active !== null && active !== undefined) data.append('active', active ? '1' : '0');
  if (showInAbout !== null && showInAbout !== undefined) data.append('show_in_about', showInAbout ? '1' : '0');
  if (employeeOrder === '') {
    data.append('employee_order', '');
  } else if (employeeOrder !== null && employeeOrder !== undefined) {
    data.append('employee_order', String(employeeOrder));
  }

  return await axios.post(
    `${API_URL}/users/edit/${id}`,
    data,
    getAuthFormHeader()
  );
};

export const updatePassword = async (currentPassword, newPassword, newPasswordConfirmation) => {
  const data = new URLSearchParams();
  data.append('current_password', currentPassword);
  data.append('password', newPassword);
  data.append('password_confirmation', newPasswordConfirmation);

  return await axios.post(
    `${API_URL}/user/password`,
    data,
    getAuthHeader()
  );
};


export const updateUserOrder = async (id, employeeOrder) => {
  const data = new FormData();
  if (employeeOrder !== '' && employeeOrder !== null && employeeOrder !== undefined) {
    data.append('employee_order', String(employeeOrder));
  } else {
    data.append('employee_order', '');
  }

  return await axios.post(
    `${API_URL}/users/edit/${id}`,
    data,
    getAuthFormHeader()
  );
};

// Funcion para actualizar rol de un usuario
export const updateRol = async (id, rol) => {
  const data = new FormData();
  data.append('roles', rol);

  return await axios.post(
    `${API_URL}/users/role/${id}`,
    data,
    getAuthFormHeader()
  );
};

// Funcion para eliminar un usuario
export const deleteUser = (id, transferToUserId) =>
  axios.delete(`${API_URL}/users/${id}`, {
    ...getAuthHeader(),
    data: { transfer_to_user_id: transferToUserId },
  })
       .then(r => r.data);

// ---- Profesionales ----
// Obtener usuarios con servicios (public)
export const getProviders = () =>
  axios.get(`${API_URL}/employees`, withoutAuthHeader)
       .then(r => r.data);

// Backward compatibility
export const getEmployees = getProviders;

export const createEmployee = data =>
  axios.post(`${API_URL}/employee`, data, getAuthJsonHeader())
       .then(r => r.data);

export const updateEmployee = (id, data) =>
  axios.put(`${API_URL}/employee/${id}`, data, getAuthJsonHeader())
       .then(r => r.data);

export const deleteEmployee = id =>
  axios.delete(`${API_URL}/employee/${id}`, getAuthHeader())
       .then(r => r.data);


// Función para obtener las noticias del blog
export const getAllArticles = async (page = null, perPage = null) => {
    let url = `${API_URL}/articles`;
    const params = [];
    if (page) params.push(`page=${page}`);
    if (perPage) params.push(`per_page=${perPage}`);
    if (params.length) url += `?${params.join('&')}`;
    const res = await fetch(url);
    const articles = await res.json();
    return articles;
}

// Función para obtener una noticia del blog
export const getArticle = async (id) => {
    const res = await fetch(`${API_URL}/articles/${id}`);
    const article = await res.json();
    return article;
}

//Función para filtrar artículos por userId
export const getArticlesbyUserId = (userId, page = null, perPage = null) => {
    const params = [];
    if (page) params.push(`page=${page}`);
    if (perPage) params.push(`per_page=${perPage}`);
    const query = params.length ? `?${params.join('&')}` : '';
    return axios
        .get(`${API_URL}/articles/user/${userId}${query}`, getAuthHeader())
        .then(r => r.data);
};


// Función para actualizar una noticia del blog
export const updateArticle = async (userId, id, title, content, image, service_id) => {

    const formData = new FormData();
    if (userId !== undefined && userId !== null && userId !== '') {
        formData.append('user_id', userId);
    }
    formData.append('title', title);
    formData.append('text', content);
    if (image) {
        formData.append('image', image);
    }
    if (service_id !== undefined && service_id !== null && service_id !== '') {
        formData.append('service_id', service_id);
    }

    // Laravel does not handle multipart/form-data on PUT requests correctly.
    // Send as POST and spoof the method to ensure file uploads work.
    formData.append('_method', 'PUT');

    return axios.post(
        `${API_URL}/articles/${id}`,
        formData,
        getAuthFormHeader()
    ).then(response => response.data);
}

// Función para crear una noticia del blog
export const createArticle = async (userId, title, content, image, service_id) => {

    const formData = new FormData();
    formData.append('user_id', userId);
    formData.append('title', title);
    formData.append('text', content);
    if (image) {
        formData.append('image', image);
    }
    if (service_id !== undefined && service_id !== null && service_id !== '') {
        formData.append('service_id', service_id);
    }

    try {
        const res = await axios.post(
            `${API_URL}/articles`,
            formData,
            getAuthFormHeader()
        );
        return res.status === 201 ? res.data : null;
    } catch (_error) {
        return null;
    }
}

// Función para eliminar una noticia del blog
export const deleteArticle = async (id) => {
    try {
        const res = await axios.delete(`${API_URL}/articles/${id}`, getAuthHeader());
        return res.status === 204 ? 1 : null;
    } catch (_error) {
        return null;
    }
}

// Función para obtener las categorias del blog
export const getAllCategories = async () => {
    const res = await fetch(`${API_URL}/categories`);
    const categories = await res.json();
    return categories;
}

// Función para obtener una categoria del blog
export const getCategory = async (id) => {
    const res = await fetch(`${API_URL}/categories/${id}`);
    const categories = await res.json();
    return categories;
}

export const createCategory = data =>
    axios.post(`${API_URL}/categories`, data, getAuthJsonHeader())
         .then(r => r.data);

export const updateCategory = (id, data) =>
    axios.post(
        `${API_URL}/categories/${id}`,
        { ...data, id, _method: 'PUT' },
        getAuthJsonHeader()
    ).then(r => r.data);

export const deleteCategory = id =>
    axios.delete(`${API_URL}/categories/${id}`, getAuthHeader())
         .then(r => r.data);

// ---- Servicios ----
export const getAllServices = async () => {
    const res = await fetch(`${API_URL}/service`);
    const services = await res.json();
    return services;
}

export const getService = async (id) => {
    const res = await fetch(`${API_URL}/service/${id}`);
    const service = await res.json();
    return service;
}

export const getServicesByEmployee = employeeId =>
    axios.get(`${API_URL}/service/employee/${employeeId}`, getAuthHeader())
        .then(r => r.data);

export const createService = data => {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            formData.append(key, value);
        }
    });
    return axios.post(`${API_URL}/service`, formData, getAuthFormHeader())
        .then(r => r.data);
};

export const updateService = (id, data) => {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            formData.append(key, value);
        }
    });
    formData.append('_method', 'PUT');
    return axios.post(`${API_URL}/service/${id}`, formData, getAuthFormHeader())
        .then(r => r.data);
};

export const deleteService = id =>
    axios.delete(`${API_URL}/service/${id}`, getAuthHeader())
        .then(r => r.data);

// ---- Clientes ----
export const getAllClients = () =>
    axios.get(`${API_URL}/client`, getAuthHeader())
        .then(r => r.data);

export const getClientsByEmployee = employeeId =>
    axios.get(`${API_URL}/client/employee/${employeeId}`, getAuthHeader())
        .then(r => r.data);

export const getClient = id =>
    axios.get(`${API_URL}/client/${id}`, getAuthHeader())
        .then(r => r.data);

export const createClient = data =>
    axios.post(`${API_URL}/client`, data, getAuthJsonHeader())
        .then(r => r.data);

export const updateClient = (id, data) =>
    axios.put(`${API_URL}/client/${id}`, data, getAuthJsonHeader())
        .then(r => r.data);

export const shareClient = (id, employee_id) =>
    axios.post(`${API_URL}/client/${id}/share`, { employee_id }, getAuthJsonHeader())
        .then(r => r.data);

export const deleteClient = id =>
    axios.delete(`${API_URL}/client/${id}`, getAuthHeader())
        .then(r => r.data);




// ——— Formularios públicos (slug) ———
export const getFormBySlug      = slug =>
  axios.get(`${API_URL}/forms/slug/${encodeURIComponent(slug)}`)
       .then(r => r.data);

export const getQuestionsBySlug = slug =>
  axios.get(`${API_URL}/forms/slug/${encodeURIComponent(slug)}/questions`)
       .then(r => r.data);

export const submitResponsesBySlug = (slug, payload) =>
  axios.post(
    `${API_URL}/forms/slug/${encodeURIComponent(slug)}/responses`,
    payload,
    withoutAuthHeader
  ).then(r => r.data);


// ——— Formularios privados (ID) ———
export const getAllForms    = () =>
  axios.get(`${API_URL}/forms`, withoutAuthHeader)
       .then(r => r.data);

export const getFormsUserCanView = userId =>
  axios.get(`${API_URL}/forms/user/${userId}`, getAuthHeader())
       .then(r => r.data);

export const getFormById    = formId =>
  axios.get(`${API_URL}/forms/${formId}`, getAuthHeader())
       .then(r => r.data);

export const createForm     = formData =>
  axios.post(`${API_URL}/forms`, formData, getAuthJsonHeader())
       .then(r => r.data);

export const updateForm     = (formId, formData) =>
  axios.put(`${API_URL}/forms/${formId}`, formData, getAuthJsonHeader())
       .then(r => r.data);

export const deleteForm     = formId =>
  axios.delete(`${API_URL}/forms/${formId}`, getAuthHeader())
       .then(r => r.data);

// búsqueda y slug
export const searchForms    = term =>
  axios.get(`${API_URL}/forms/search/${encodeURIComponent(term)}`, getAuthHeader())
       .then(r => r.data);

// ——— Preguntas anidadas ———
export const getQuestionsByForm = formId =>
  axios.get(`${API_URL}/forms/${formId}/questions`, withoutAuthHeader)
       .then(r => r.data);

export const updateAvatar = formData =>
  axios.post(`${API_URL}/user/avatar`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  }).then(r => r.data);

export const createQuestion    = (formId, data) =>
  axios.post(`${API_URL}/forms/${formId}/questions`, data, getAuthHeader())
       .then(r => r.data);

export const updateQuestion    = (questionId, data) =>
  axios.put(`${API_URL}/questions/${questionId}`, data, getAuthHeader())
       .then(r => r.data);

export const deleteQuestion    = questionId =>
  axios.delete(`${API_URL}/questions/${questionId}`, getAuthHeader())
       .then(r => r.data);

export const getQuestionById   = questionId =>
  axios.get(`${API_URL}/questions/${questionId}`, withoutAuthHeader)
       .then(r => r.data);

// ——— Respuestas anidadas ———
export const getResponsesByForm = (formId, page = 1, perPage = 5) => {
  const config = getAuthHeader();
  config.params = { page, per_page: perPage };
  return axios.get(`${API_URL}/forms/${formId}/responses`, config)
    .then(r => r.data);
};

export const createResponse     = (formId, payload) =>
  axios.post(`${API_URL}/forms/${formId}/responses`, payload, withoutAuthHeader)
       .then(r => r.data);  



export const updateResponse     = (responseId, payload) =>
  axios.put(`${API_URL}/responses/${responseId}`, payload, getAuthHeader())
       .then(r => r.data);

export const deleteResponse     = responseId =>
  axios.delete(`${API_URL}/responses/${responseId}`, getAuthHeader())
       .then(r => r.data);

export const deleteResponsesByForm = formId =>
  axios.delete(`${API_URL}/forms/${formId}/responses`, getAuthHeader())
       .then(r => r.data);

export const deleteResponsesByDate = (formId, timestamp) =>
  axios.delete(
    `${API_URL}/forms/${formId}/responses/date/${encodeURIComponent(timestamp)}`,
    getAuthHeader()
  ).then(r => r.data);

export const getResponseById    = responseId =>
  axios.get(`${API_URL}/responses/${responseId}`, getAuthHeader())
       .then(r => r.data);
    

//
//
//  Aqui empiezan todos los endpoint para los Roles
//
//

// Función para obtener todos los roles
export const getAllRoles = async () => {
    return await axios.get(`${API_URL}/roles`).then(response => response.data);
}

export const getRol = async (id) => {
    return await axios.get(`${API_URL}/roles/${id}`).then(response => response.data);
}

export const createRol = async (name, permissions) => {

    const formData = new FormData();
    formData.append('name', name);
    permissions.forEach(element => {
        formData.append('permissions[]', element);
    });

    const config = {
        headers: {
            // 'content-type': 'multipart/form-data',
        },
        withCredentials: true,
    }

    return await axios.post(`${API_URL}/roles`, formData, config);
}


export const deleteRol = async (id) => {
    const config = {
        headers: {
            'content-type': 'multipart/form-data',
        },
        withCredentials: true,
    }
    return await axios.delete(`${API_URL}/roles/${id}`, config);
}

export const getPermissions = async () => {
    return await axios.get(`${API_URL}/permissions`).then(response => response.data);
}

export const getPermission = async (id) => {
    return await axios.get(`${API_URL}/permissions/${id}`).then(response => response.data);
}

// ---- Citas ----
export const getAppointments = () =>
  axios.get(`${API_URL}/appointment`, getAuthHeader())
       .then(r => r.data);

export const getAppointmentsByRole = (role, id) =>
  axios.get(`${API_URL}/appointments/user/${role}/${id}`, getAuthHeader())
       .then(r => r.data);

// Crear una cita desde el formulario público (sin autenticación)
export const bookAppointment = data =>
  axios.post(`${API_URL}/appointment/book`, data, withoutAuthHeader)
       .then(r => r.data);

export const createAppointment = data =>
  axios.post(`${API_URL}/appointment`, data, getAuthFormHeader())
       .then(r => r.data);

export const updateAppointment = (id, data) => {
  // Laravel no procesa correctamente multipart/form-data en peticiones PUT.
  // Se envía la solicitud como POST indicando el método deseado.
  data.append('_method', 'PUT');
  return axios.post(`${API_URL}/appointment/${id}`, data, getAuthFormHeader())
    .then(r => r.data);
};

export const shareAppointment = (id, employee_id) =>
  axios.post(`${API_URL}/appointment/${id}/share`, { employee_id }, getAuthJsonHeader())
       .then(r => r.data);

export const deleteAppointment = id =>
  axios.delete(`${API_URL}/appointment/${id}`, getAuthHeader())
       .then(r => r.data);

export const getAppointmentCounts = () =>
  axios.get(`${API_URL}/appointments/countByClient`, getAuthHeader())
       .then(r => r.data);

export const getServiceStats = () =>
  axios.get(`${API_URL}/appointments/serviceStats`, getAuthHeader())
       .then(r => r.data);

export const getEmployeeStats = () =>
  axios.get(`${API_URL}/appointments/employeeStats`, getAuthHeader())
       .then(r => r.data);

export const getTopClientsMonthly = () =>
  axios.get(`${API_URL}/appointments/topClientsMonthly`, getAuthHeader())
       .then(r => r.data);

export const getActivities = () =>
  axios.get(`${API_URL}/appointments/activities`)
       .then(r => r.data);

export const registerActivity = (id, data) =>
  axios.post(`${API_URL}/appointments/activities/${id}/register`, data)
       .then(r => r.data);


export const getActivitiesAdmin = () =>
  axios.get(`${API_URL}/appointments/activities/admin`, getAuthHeader())
       .then(r => r.data);

export const getActivityRegistrations = id =>
  axios.get(`${API_URL}/appointments/activities/${id}/registrations`, getAuthHeader())
       .then(r => r.data);

export const deleteActivityRegistration = (activityId, registrationId) =>
  axios.delete(`${API_URL}/appointments/activities/${activityId}/registrations/${registrationId}`, getAuthHeader())
       .then(r => r.data);

export const updateActivityRegistration = (activityId, registrationId, data) =>
  axios.put(`${API_URL}/appointments/activities/${activityId}/registrations/${registrationId}`, data, getAuthJsonHeader())
       .then(r => r.data);


// ---- Reportes ----
export const getReports = clientId => {
  const config = getAuthHeader();
  if (clientId) {
    config.params = { client: clientId };
  }
  return axios.get(`${API_URL}/reports`, config)
    .then(r => r.data);
};

export const getReport = id =>
  axios.get(`${API_URL}/reports/${id}`, getAuthHeader())
       .then(r => r.data);

export const createReport = data =>
  axios.post(`${API_URL}/reports`, data, getAuthJsonHeader())
       .then(r => r.data);

export const updateReport = (id, data) =>
  axios.put(`${API_URL}/reports/${id}`, data, getAuthJsonHeader())
       .then(r => r.data);

export const deleteReport = id =>
  axios.delete(`${API_URL}/reports/${id}`, getAuthHeader())
       .then(r => r.data);

// ---- Historias Clínicas ----
export const getClinicalHistory = clientId => {
  const config = getAuthHeader();
  config.params = { client: clientId };
  return axios.get(`${API_URL}/clinicalHistories`, config).then(r => r.data[0]);
};

export const createClinicalHistory = data =>
  axios.post(`${API_URL}/clinicalHistories`, data, getAuthJsonHeader())
       .then(r => r.data);

export const updateClinicalHistory = (id, data) =>
  axios.put(`${API_URL}/clinicalHistories/${id}`, data, getAuthJsonHeader())
       .then(r => r.data);

export const downloadClinicalHistoryPdf = id =>
  axios.get(`${API_URL}/clinicalHistories/${id}/pdf`, { ...getAuthHeader(), responseType: 'blob' })
       .then(r => r.data);

// ---- Multimedia ----
export const getMedia = () =>
  axios.get(`${API_URL}/media`, getAuthHeader())
       .then(r => r.data);

export const uploadMedia = file => {
  const data = new FormData();
  data.append('file', file);
  return axios.post(`${API_URL}/media`, data, getAuthFormHeader())
    .then(r => r.data);
};


export const deleteMedia = path =>
  axios.delete(`${API_URL}/media/${encodeURIComponent(path)}`, getAuthHeader())
       .then(r => r.data);

// ---- Disponibilidad ----
export const getAvailability = () =>
  axios.get(`${API_URL}/availability`, getAuthHeader())
       .then(r => r.data);

export const updateAvailability = data =>
  axios.post(`${API_URL}/availability`, data, getAuthJsonHeader())
       .then(r => r.data);

export const getAvailabilitySlots = (employeeId, date) => {
  const config = { ...withoutAuthHeader, params: { employee_id: employeeId, date } };
  return axios.get(`${API_URL}/availability/slots`, config).then(r => r.data);
};

// ---- Formaciones ----
export const getAllFormations = () =>
  axios.get(`${API_URL}/formations`, withoutAuthHeader)
    .then(r => r.data);

export const getFormation = id =>
  axios.get(`${API_URL}/formations/${id}`, withoutAuthHeader)
    .then(r => r.data);

export const createFormation = data =>
  axios.post(`${API_URL}/formations`, data, getAuthJsonHeader())
    .then(r => r.data);

export const updateFormation = (id, data) =>
  axios.post(`${API_URL}/formations/${id}`, { ...data, _method: 'PUT' }, getAuthJsonHeader())
    .then(r => r.data);

export const deleteFormation = id =>
  axios.delete(`${API_URL}/formations/${id}`, getAuthHeader())
    .then(r => r.data);
